<template>
    <div id="pcEducation">
        <tabtop></tabtop>
        <div class="solution1">
            <img :src="url+banner.images[1]" alt=""  @click="jumpbannerpage(banner.url,1)">
        </div>

        <div class="pcEducation1">
            <p class="title">亲子教育行业的痛点</p>
            <img src="@/assets/solution/pcEducation1.png" alt="">
        </div>
        <div class="solution4">
            <ul>
                <li v-for="(item,index) in solution4" :key="index"  class="wow animate__animated animate__fadeIn">
                    <div>
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{item.subtitle}}</p> 
                        <img :src="item.icon" alt="">
                    </div>
                </li>
            </ul>
        </div>
        <div class="pcEducation2">
            <button class="button1" @click="submit(false)">免费试用</button>
            <button class="button2" @click="submit(true)">立即咨询</button>
        </div>
        <webbottom></webbottom>
        <mydialog v-if="showtc2" @tcstatus="tcstatus" :dialogVisible1="tcshow"></mydialog>
    </div>
</template>

<script>
var that
import mydialog from '@/components/dialog/dialog.vue'
import tabtop from '@/components/tab/tab.vue'
import webbottom from '@/components/bottom/bottom.vue'
import { rotationmap } from '@/api/api'
export default {
    name:"solution",
    components: {
        tabtop,
        webbottom,
        mydialog
    },
    data(){
        return {
            showtc2:false,
            tcshow:true,
            url : window.url,
            banner: {}, 


            solution4:[
                {
                    icon:require('@/assets/solution/pcEducation2.png'),
                    title:"亿宝易帮你解决痛点打造教育行业营销新生态",
                    subtitle:"打通招生获客、学员促活、销售转化、学员管理闭环体系",
                },
                {
                    icon:require('@/assets/solution/pcEducation3.png'),
                    title:"通过渠道引流活码功能提升招生效果",
                    subtitle:"亿宝易平台中的渠道活码功能，可查看投放效果，优惠引流策略，可以一码多人，为每个二维码设置不同的标签规则，统计扫码数据，帮助企业分析渠道质量，了解客户源 ",
                },
                {
                    icon:require('@/assets/solution/pcEducation4.png'),
                    title:"营销裂变，降低营销成本，提升营销效果",
                    subtitle:"通过有吸引力的奖品，只做任务海报，借用任务裂变、抽奖裂变红包裂变及好友裂变等多种线上裂变活动玩法，帮助企业短时间内获得更多客户资源",
                },
                {
                    icon:require('@/assets/solution/pcEducation5.png'),
                    title:"班级群管理，轻松制定运营计划",
                    subtitle:"无限拉群、标签建群实现自动化拉群,设置群发SOP，无须担心漏发消息，根据学员生命周期指定自动化策略，提升学员转化效率",
                },
                {
                    icon:require('@/assets/solution/pcEducation6.png'),
                    title:"实时统计数据报表，招生转化数据渠道，管理更有效",
                    subtitle:"学生增长统计、电话/微信工作效率统计跟进过程等, 清晰了解团队工作成果；销售漏斗，订单管理目标完成率等数据一目了然，可以有效管理，提升校区效益",
                },
                {
                    icon:require('@/assets/solution/pcEducation7.png'),
                    title:"亿宝易系统提供完整顾客经营数字化解决方案",
                    subtitle:"帮助实体门店搭建私域流量池，构建可持续发展的顾客经营体系",
                }
            ]
        }
    },
     mounted(){
        that = this
        rotationmap({'type':5}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner = response.data.data[0]
            //初始化动画
            that.$nextTick(()=>{
                that.$wow.init()
            })
        })
    },
    methods:{
        tcstatus(e){
            this.showtc2 = e
        },
        submit(e){
            this.showtc2 = true
            this.tcshow = e
        },
        jumpbannerpage(e,y){
            this.showtc2 = true
            let url = e.split(',')
            if(url[y] != this.$route.path) {
                this.$router.push(url[y])
            }
        }
    }
}
</script>

<style lang="less">
:root {
    --web-title-fontsize: 30px;
    --web-subtitle-fontsize: 22px;
    --web-text-fontsize: 16px;
} 
@media (min-width:750px) {
    #pcEducation{
        .solution1{
            img{
                width: 100%;
            }
        }
        .pcEducation1{
            margin:0 auto 0;
            background: linear-gradient(180deg, rgba(218,230,254,0.8) 0%, #F9FBFF 100%);
            padding: 70px 0;
            .title{
                font-size: var(--web-title-fontsize);
                font-weight: 800;
                color: #222222;
                text-align: center;
            }
            img{
                width: 1189px;
                display: block;
                margin:53px auto 120px;
            }
        }
        .pcEducation2{
            display: flex;
            justify-content: center;
            margin-bottom: 57px;
            .button1{
                margin-right: 60px;
                background: #355EFC;
                border-radius: 61px 61px 61px 61px;
                font-size: var(--web-text-fontsize);
                font-weight: 500;
                color: #FFFFFF;
                text-align: center;
                padding: 18px 60px;
                cursor: pointer;
            }
            .button2{
                border-radius: 61px 61px 61px 61px;
                border: 1px solid #355EFC;
                font-size: var(--web-text-fontsize);
                font-weight: 500;
                color: #355EFC;
                padding: 18px 60px;
                background-color: transparent;
                cursor: pointer;
            }
        }
        .solution4{
            margin-top: 40px;
            ul{
                li{
                    background: linear-gradient(180deg, #EFF4FF 0%, rgba(197,214,255,0) 100%);
                    margin-bottom: 100px;
                    div{
                        width: 1300px;
                        margin:0 auto;
                        padding: 80px 0;
                    }
                    .p1{
                        font-size: var(--web-title-fontsize);
                        font-weight: 800;
                        color: #222222;
                        text-align: center;
                        margin-bottom: 20px;
                    }
                    .p2{
                        width: 1000px;
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: 500;
                        color: #808080;
                        text-align: center;
                        margin:0 auto 49px;
                    }
                    img{
                        width: 806px;
                        display: block;
                        margin:0 auto 60px;
                    }
                }
            }
        }
    }
}
@media screen and (max-width:750px) {
    #pcEducation{
        .solution1{
            img{
                width: 100%;
            }
        }
        .pcEducation1{
            margin:0 auto 0;
            background-color: #F5F8FF;
            padding: 1.875rem 0;
            .title{
                font-size: 1.5rem;
                font-weight: 800;
                color: #222222;
                text-align: center;
            }
            img{
                width: 90%;
                display: block;
                margin:53px auto 120px;
            }
        }
        .solution4{
            margin-top: 1.75rem;
            ul{
                width: 100%;
                margin:0 auto;
                li{
                    .p1{
                        font-size: 1.5rem;
                        font-weight: 800;
                        color: #222222;
                        text-align: center;
                        margin-bottom: 1.25rem;
                    }
                    .p2{
                        width: 90%;
                        font-size: 1.25rem;
                        font-weight: 500;
                        color: #808080;
                        text-align: center;
                        margin:0 auto 3.0625rem;
                    }
                    img{
                        width: 100%;
                        margin-bottom: 3.75rem;
                    }
                }
            }
        }
        .pcEducation2{
            display: flex;
            justify-content: center;
            margin-bottom: 20px;
            .button1{
                margin-right: 30px;
                background: #355EFC;
                border-radius: 61px 61px 61px 61px;
                font-size: 20px;
                font-weight: 500;
                color: #FFFFFF;
                text-align: center;
                padding: 10px 20px;
            }
            .button2{
                border-radius: 61px 61px 61px 61px;
                border: 1px solid #355EFC;
                font-size: 20px;
                font-weight: 500;
                color: #355EFC;
                padding: 10px 20px;
                background-color: transparent;
            }
        }
    }
}
</style>